import React from 'react'
import { observer } from 'mobx-react'

export default observer(({ message = '', size = 'small' }) => {
  
  return (
    <div className={ `loading loading--${ size }` }>
      <div className="loading__indicator">
        <span />
      </div>
      { message && (
        <div className="loading__message">
          { message }
        </div>
      )}
    </div>
  )
})
